<template>
  <van-overlay show z-index="1000">
    <div class="overlay-follow-wrapper relative">
      <div class="swiper mySwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <follow-item @close="onClose">
              <div class="overlay-message px-10 text-center">
                <div  class="mb-5">敬请期待!</div>
                <img :src="url" width="120" height="120" @load="onLoad" :alt="altText" />
              </div>
            </follow-item>
          </div>
          <div class="swiper-slide">
            <follow-item @close="onClose">
              <div class="w-full box-border px-10">
                <div class="box-border rounded-medium text-center w-full relative">
                  <div class="overlay-message mb-2">
                    <div style="font-size: 18px">感谢参与</div>
                    <div class="text-medium">长按关注“{{ altText }}”公众号，获取提交内容！</div>
                  </div>
                  <img :src="url" width="120" height="120" @load="onLoad" :alt="altText" />
                </div>
              </div>
            </follow-item>
          </div>
          <div class="swiper-slide">
            <follow-item @close="onClose">
              <div class="overlay-message px-10 text-center">
                <div class="mb-5">敬请期待!</div>
                <img :src="url" width="120" height="120" @load="onLoad" :alt="altText" />
              </div>

            </follow-item>
          </div>
        </div>
        <div class="follow-close" @click="onClose">
          <van-icon name="cross" size="24px" @click.native.stop="onClose" />
        </div>
      </div>

    </div>
  </van-overlay>
</template>

<script>
import VueQr from 'vue-qr'
import { logoSrc } from 'dygc'
import FollowItem from './FollowItem'
// import Swiper from 'swiper'


export default {
  name: 'OverlayQrCodeFollow',
  components: { FollowItem, VueQr },

  props: {
    url: String,
    message: {
      type: String,
      default: '只有公众号粉丝可作答'
    },
    showClose: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      imgLoad: false,
      altText: process.env.NODE_ENV === 'development' ? '优数调研家' : '调研工厂+',
      logoSrc,
      swiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true
        }
      }
    }
  },
  methods: {
    onLoad() {
      this.imgLoad = true
      console.log('img load')
    },
    onClose() {
      this.$emit('close')
    },
    onError(err) {
      if (process.env.NODE_ENV === 'development') {
        // console.log(err)
        alert(this.url)
      }
    },
    initSwiper() {
      const swiper = new Swiper(".mySwiper", {
        // slidesPerView: "auto",
        // spaceBetween: -160,
        // centeredSlides: true,
        // initialSlide:1,
        // loop: true,
        // effect: 'coverflow',
        // grabCursor: true,
        // centeredSlides: true,
        // slidesPerView: 'auto',
        // initialSlide:1,
        // loop: true,
        // coverflowEffect: {
        //   rotate: 50,
        //   stretch: 0,
        //   depth: 100,
        //   modifier: 1,
        //   slideShadows: true,
        // }


        effect: "cube",
        initialSlide:1,
        loop:true,
        grabCursor: true,
        cubeEffect: {
          shadow: true,
          slideShadows: true,
          shadowOffset: 20,
          shadowScale: 0.94,
        },
      })
    }
  },
  mounted() {
    setTimeout(()=>{
      this.initSwiper()
    },100)
  }
}
</script>

<style lang="scss" scoped>
.overlay-follow-wrapper {
  @apply absolute top-0 bottom-0 flex items-center;
  //width: 343px;
  //margin: 0 auto;
  //left: 50%;
  //transform: translateX(-50%);

  left: 0;
  right: 0;
  padding: 0 20px;

  .follow-close {
    position: absolute;
    right: 20px;
    top: 20px;
    border: 1px solid #ccc;
    border-radius: 50%;
    width: 28px;
    height: 28px;
    text-align: center;

    .van-icon {
      line-height: 28px;
      color: #ccc;
    }
  }
}

.overlay-message {
  color: #f08537;
}
</style>

<style lang="scss">

.swiper {
  width: 100%;
  padding-top: 50px;
  padding-bottom: 50px;
}

.swiper-slide {
  background-position: center;
  background-size: cover;
  //max-width: 343px;

  //.follow-item {
  //  opacity: 0.5;
  //  transform: scale(0.8);
  //  transition: all .3s;
  //}

  .coming-soon {
    background-color: #fff;
  }

  &.swiper-slide-active {
    //z-index: 1000;
    //transform: scale(1);

    //.follow-item {
    //  opacity: 1;
    //  transform: scale(1);
    //}
  }
}
</style>